import actionTypes from "../../actions/actionTypes";
import organizationSettingsReducer from "./organizationSettingsReducer";
import rolesAndPermissionsReducer from "./rolesAndPermissionsReducer";
import userManagementReducer from "./userManagementReducer";
import certificateManagementReducer from "./certificateManagementReducer";
import groupManagementReducer from "./groupManagementReducer";
import engagementCenterReducer from "./engagementCenterReducer";
import { combineReducers } from "redux";

const initialState = {
  users: null,
};

const adminReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.adminTypes.GET_SEARCH_USERS:
      return { ...state, users: payload };

    default:
      return state;
  }
};

const adminRootReducer = combineReducers({
  adminReducer,
  organizationSettingsReducer,
  rolesAndPermissionsReducer,
  userManagementReducer,
  certificateManagementReducer,
  groupManagementReducer,
  engagementCenterReducer,
});

export default adminRootReducer;
